var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skiptranslate",attrs:{"id":"recaptcha-validate","data-sitekey":_vm.recaptchaKey}},[_vm._v("Please wait...")])
}
var staticRenderFns = []

export { render, staticRenderFns }